// eslint-disable-next-line no-shadow
export enum BillingType {
   'CLOSED' = 'closed',
   'OPEN' = 'open'
}
